import { render, staticRenderFns } from "./athub-collapse.vue?vue&type=template&id=38615451&"
import script from "./athub-collapse.vue?vue&type=script&lang=js&"
export * from "./athub-collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports